import type { CiStatus, EnvState, GateType, StageKind, TaskStatus } from "../api/types";

export type PillColor =
  | "default"
  | "gray"
  | "brown"
  | "orange"
  | "yellow"
  | "green"
  | "blue"
  | "purple"
  | "pink"
  | "red";

export const STATUS_META: Record<TaskStatus, { label: string; color: PillColor }> = {
  ready: { label: "Ready", color: "gray" },
  working: { label: "Agent working", color: "blue" },
  ai_review: { label: "AI review", color: "purple" },
  human_review: { label: "Human review", color: "orange" },
  waiting_on_human: { label: "Waiting on human", color: "yellow" },
  needs_attention: { label: "Needs attention", color: "red" },
  waiting_on_github: { label: "Waiting on GitHub", color: "brown" },
  paused: { label: "Paused", color: "default" },
  cancelled: { label: "Cancelled", color: "default" },
  done: { label: "Done", color: "green" },
};

export function statusMeta(s: string): { label: string; color: PillColor } {
  return STATUS_META[s as TaskStatus] ?? { label: s, color: "gray" };
}

export const CI_META: Record<CiStatus, { label: string; color: PillColor }> = {
  pending: { label: "CI pending", color: "yellow" },
  success: { label: "CI passed", color: "green" },
  failure: { label: "CI failed", color: "red" },
};

export const ENV_STATE_COLOR: Record<EnvState, PillColor> = {
  provisioning: "yellow",
  starting: "yellow",
  running: "green",
  stopping: "orange",
  stopped: "gray",
  terminated: "default",
  failed: "red",
};

export const GATE_LABEL: Record<GateType, string> = {
  ai_review: "AI review",
  cross_task_review: "Cross-task review",
  human_review: "Human review",
};

export const GATE_COLOR: Record<GateType, PillColor> = {
  ai_review: "purple",
  cross_task_review: "pink",
  human_review: "orange",
};

export const STAGE_KIND_LABEL: Record<StageKind, string> = {
  human: "Human",
  agent: "Agent",
  integration: "Integration",
  done: "Done",
};

export const ACTIVE_STATUSES: TaskStatus[] = [
  "ready",
  "working",
  "ai_review",
  "human_review",
  "waiting_on_human",
  "needs_attention",
  "waiting_on_github",
];
